import React, { Component } from 'react';
//import DashboardFilters from './dashboard-filters'

export default class TcWidget extends Component {
    constructor(props) {
        super(props);
    }

    handleClick(coordinatorId, coordinatorName) {
        const dbFilter = this.props.filter;
        dbFilter.label = `${dbFilter.label} : ${coordinatorName}`;

        if (!dbFilter.filter.where.and) {
            let where = { and: [] };
            if (!_.isEmpty(dbFilter.filter.where)) {
                where.and.push(dbFilter.filter.where);
            }

            dbFilter.filter.where = where;
        }

        dbFilter.filter.where.and.push({ coordinatorId: coordinatorId });
        appStore.viewStore.openFilePageWithFilter(dbFilter);
    }

    render() {
        const tcRows = _.map(this.props.tcs, tc => {
            const name = tc.isDisabled ? tc.name + '*' : tc.name;

            return (
                <tr
                    key={tc.coordinatorId}
                    onClick={() => {
                        this.handleClick(tc.coordinatorId, tc.name);
                    }}
                >
                    <td>{name}</td>
                    <td>{tc.count}</td>
                </tr>
            );
        });

        return (
            <div className="panel panel-default">
                <div className="panel-heading">{this.props.label}</div>
                <div className="panel-body">
                    <table className="table table-condensed table-hover">
                        <tbody>{tcRows}</tbody>
                    </table>
                    <span className="pull-right">*disabled</span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/dashboard/tc-widget.js